import { render, staticRenderFns } from "./AppointmentItem.vue?vue&type=template&id=6f5e7b70&scoped=true"
import script from "./AppointmentItem.vue?vue&type=script&lang=js"
export * from "./AppointmentItem.vue?vue&type=script&lang=js"
import style0 from "./AppointmentItem.vue?vue&type=style&index=0&id=6f5e7b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e7b70",
  null
  
)

export default component.exports